<div class="zone">
  <i class="fas fa-lightbulb" aria-hidden="true"></i>
  {{ 'HELPER.DO_YOU_KNOW' | translate }}
  <button mat-button (click)="open()">{{ 'HELPER.DISCOVER' | translate }}</button>
</div>
